import React from 'react'
import { View, FilterModal } from '@/components'
import { TypeGuards } from '@codeleap/common'
import { APIClient } from '@/services'
import { variantProvider } from '@/app'

const extraData = {
  climate_actionability: { label: 'Climate actionability', order: 1, multiple: true },
  climate_priority: { label: 'Climate priority', order: 2, multiple: true },
  country: { label: 'Country', order: 3, multiple: true },
  department: { label: 'Department', order: 4, multiple: true },
  format: { label: 'Format', order: 5, multiple: true },
  gender: { label: 'Gender', order: 6, multiple: true },
  inbound_source: { label: 'Inbound Source', order: 7, multiple: true },
  seniority: { label: 'Seniority', order: 8, multiple: true },
  source: { label: 'Source', order: 9, multiple: true },
  theme: { label: 'Theme', order: 10, multiple: true },
  satisfaction_at_work: { label: 'Work Satisfaction', order: 11, multiple: true }
}

export function FilterFeed({ show = false }) {
  const communityFilterOptions = APIClient.Community.useCommunityFilterOptions()?.data
  const filters = APIClient.Community.filtersStore.use()

  const applyFilter = React.useCallback((key, value) => {
    APIClient.Community.filtersStore.set({ [key]: value })
  }, [])

  const filterSources = React.useMemo(() => {
    if (TypeGuards.isNil(communityFilterOptions)) return []
    return Object.entries(communityFilterOptions)
      .map(f => {
        const [key, value] = f
        const meta = extraData[key] || {}

        return {
          label: meta.label || key,
          order: meta.order ?? 999,
          multiple: meta.multiple ?? true,
          key,
          state: filters[key] || [],
          setter: value => applyFilter(key, value),
          data: value
        }
      })
      .sort((a, b) => a.order - b.order)
  }, [communityFilterOptions, filters, applyFilter])

  return (
    <View css={[styles.wrapper, { opacity: show ? 1 : 0 }]}>
      {filterSources?.map(f => {
        return (
          <FilterModal
            key={f.key}
            sections={f}
            showBadge={f.key !== 'sort_by'}
            clearFilters={f.key !== 'sort_by'}
            hideClearOption={f.key === 'sort_by'}
          />
        )
      })}
    </View>
  )
}

const styles = variantProvider.createComponentStyle(
  theme => ({
    wrapper: {
      ...theme.spacing.gap(1),
      ...theme.presets.fullWidth,
      overflow: 'hidden',
      transition: 'all .2s',
      overflowX: 'auto',
      overflowY: 'hidden'
    }
  }),
  true
)
